import React from 'react';

import { navigate } from '@reach/router';
import { useSelector } from 'react-redux';

import { env } from '../../utils/env';
import Button from '../Button/Button';
import getMarkerIcon from '../Map/markers';
import styles from './LocationInfo.module.scss';

export function LocationInfo({ locationName, locationAddress }) {
  const robotAccordionTexts = useSelector((store) => store.data.robotAccordion);
  useSelector((store) => store.state.page);
  const currentService = useSelector((store) => store.state.service);
  const currentFranchise = useSelector((store) => store.state.city?.franchise);
  const currentRobot = useSelector((store) => store.state.robot);
  const currentAge = useSelector((store) => store.state.age);
  const currentLocationId = useSelector((store) => store.state.locationId);

  const handleBackToMapSelection = () => {
    navigate(
      `${env.PUBLIC_URL}/${currentFranchise.id}/${currentService.value}/${
        currentAge?.value || 0
      }/${currentRobot.id}/${currentLocationId}`,
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.imageWrapper}>
        <img src={getMarkerIcon()} alt="img" />
      </div>
      <div>
        <div className={styles.title}>{locationName}</div>
        <div className={styles.subtitle}>{locationAddress}</div>
      </div>
      <div className={styles.buttonWrapper}>
        <Button
          type={'primary'}
          text={robotAccordionTexts.primary}
          onClick={handleBackToMapSelection}
        />
      </div>
    </div>
  );
}
